import React from 'react';
export function AnnouncementBar() {
  return <aside className="flex h-11 w-full items-center justify-center bg-pine px-3" data-id="element-19" data-mp="2tgqpao3xs0lk">
      <p className="whitespace-nowrap text-center text-[9px] font-semibold uppercase tracking-[0.08em] text-white sm:text-[11px] md:text-xs" data-id="element-20" data-mp="olbx1wymhaey">
        THE COMPLETE GIRLS&apos; LACROSSE COACHING SYSTEM
      </p>
    </aside>;
}